import { useState } from 'react'
import noImageFallback from '../../../images/no-image-background.jpg'

const ImageWithFallback = ({ src, srcFallback, className, alt = '', style, onClick }) => {
    const [fallbackInUse, setFallback] = useState(false)

    return (
        <img
            src={src}
            className={className}
            alt={alt}
            style={style}
            onClick={onClick}
            onError={({ currentTarget }) => {
                if(fallbackInUse) {
                    currentTarget.onerror = null;
                    currentTarget.src = noImageFallback;
                } else {
                    setFallback(true)
                    currentTarget.onerror = null;
                    currentTarget.src = srcFallback;
                }
            }}
        />
    )
}

export default ImageWithFallback
